module.exports = __webpack_public_path__ + "img/behind-the-waves.a6df07ee.jpg";